<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Selections</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (modelNumberSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Model Number:</label>
            <select class="halfWidthInputField" #modelNumberInput
              [class.invalidConfigurationSelection]="isInvalidSelection(modelNumberSelection.Name)"
              (change)="selectionChanged(modelNumberSelection, modelNumberInput.value)"
              [value]="modelNumberSelection.Value.toString()">
              @for (allowable of modelNumberSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="modelNumberSelection.Value && modelNumberSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
